const config = {
  routes: {
    label: 'Closure FAQ',
    prefix: '/closure_faq',
  },
}

export default config
